import type { LegacyHandlers } from '../legacy-mirrored-builder';

type WorkflowHandlers = Pick<LegacyHandlers,
| 'createAction' | 'updateAction' | 'deleteAction' | 'reorderAction'
| 'createRole' | 'updateRole' | 'deleteRole'
| 'createStatus' | 'updateStatus' | 'deleteStatus' | 'reorderStatus'
>;

// TODO: implement as workflow (actions/roles/statuses) moves to the new model.
export const createLegacyWorkflowHandlers = (): WorkflowHandlers => ({});
